(function(){
  if (window.__cjMenuFallback) return;
  window.__cjMenuFallback = true;
  function setOpen(open, btn) {
    var shell = document.getElementById('modals-leftDrawer');
    if (!shell) return;
    var overlay = shell.children[0];
    var host = shell.querySelector('.drawer-transition-host');
    var slot = shell.querySelector('#left-drawer-slot');
    var nav = slot && slot.firstElementChild;
    shell.style.display = open ? 'block' : 'none';
    if (overlay) overlay.style.display = open ? 'block' : 'none';
    if (host) host.style.display = open ? 'block' : 'none';
    if (nav) nav.style.display = open ? 'block' : 'none';
    shell.setAttribute('data-cj-fallback-open', open ? '1' : '0');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.classList.toggle('cj-menu-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function(ev) {
    var btn = ev.target.closest && ev.target.closest('[data-menu-drawer-toggle]');
    if (btn && !btn.closest('noscript')) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
      var shell = document.getElementById('modals-leftDrawer');
      setOpen(!(shell && shell.getAttribute('data-cj-fallback-open') === '1'), btn);
      return;
    }
    var shell = document.getElementById('modals-leftDrawer');
    if (shell && shell.getAttribute('data-cj-fallback-open') === '1' && ev.target === shell) setOpen(false);
  }, true);
  document.addEventListener('keydown', function(ev) { if (ev.key === 'Escape') setOpen(false); });
})();
